.container {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: map.get($spacing-scale, 's-1h') map.get($spacing-scale, 's-1');
  border-radius: map.get($radius, 'xs');
  width: 100%;
  text-decoration: none;
  cursor: pointer;
  position: relative;

  @include transition(background-color, border-radius);

  &:hover {
    background-color: var(--color-surface-alt);
    border-radius: map.get($radius, 'sm');

    .externalIcon {
      opacity: 1;
    }
  }
}

.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.icon {
  flex-shrink: 0;

  // Override SocialIcon's default 32px size to 24px
  width: 24px !important;
  height: 24px !important;

  img {
    width: 24px !important;
    height: 24px !important;
  }
}

.labelWrapper {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @include body-regular;
  color: var(--color-text-primary);
}

.labelTooltip {
  display: inline !important; // override inline-flex so text-overflow: ellipsis works on parent
  position: static !important; // let tooltip popup position relative to .container instead
}

.label {
  // inherits typography from .labelWrapper
}

.actions {
  display: flex;
  align-items: center;
  gap: 6px;
  position: absolute;
  right: map.get($spacing-scale, 's-1');
  top: 50%;
  transform: translateY(-50%);
  padding-left: 8px;
  background: linear-gradient(to right, transparent, var(--color-surface-alt) 6px);
  opacity: 0;
  pointer-events: none;

  @include transition(opacity);

  .container:hover & {
    opacity: 1;
    pointer-events: auto;
  }
}

.copyButton {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  background: none;
  border: none;
  border-radius: map.get($radius, 'sm');
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid var(--color-primary-base);
    outline-offset: 1px;
  }
}

.externalIcon {
  flex-shrink: 0;
  color: var(--color-text-tertiary);
}
